export const MATCH_CONFIDENCE = {
    npn: 1,
    synthetic_email: 1,
    provider_contract: 0.95,
    registration: 1,
    email: 0.9,
    link: 0.85,
    full_name: 0.6,
    auto_create: 0.5,
};
const NPN_FORM_KEYS = ["npn", "NPN", "agentNpn", "nationalProducerNumber"];
const FIRST_NAME_FORM_KEYS = ["firstName", "first_name", "agentFirstName"];
const LAST_NAME_FORM_KEYS = ["lastName", "last_name", "agentLastName"];
const EMAIL_FORM_KEYS = ["email", "agentEmail"];
export function normalizeNpn(value) {
    if (!value)
        return null;
    const digits = value.replace(/\D/g, "");
    return digits.length >= 4 ? digits : null;
}
export function normalizeEmail(value) {
    const trimmed = value?.trim().toLowerCase();
    if (!trimmed || !trimmed.includes("@"))
        return null;
    return trimmed;
}
export function upstreamPlaceholderEmail(source, externalId) {
    const safe = externalId.replace(/[^a-zA-Z0-9_-]/g, "_").slice(0, 120);
    return `upstream+${source}+${safe}@altura.internal`;
}
export function isUpstreamPlaceholderEmail(email) {
    const normalized = email.trim().toLowerCase();
    return normalized.endsWith("@altura.internal") && normalized.startsWith("upstream+");
}
/** True when a managed agent record still needs a real portal email / login. */
export function agentNeedsPortalClaim(user) {
    const email = user.email.trim().toLowerCase();
    if (isUpstreamPlaceholderEmail(email))
        return true;
    return email.endsWith("@altura.internal") && !user.canLogin;
}
/** True when an agent has signed into the portal at least once. */
export function isAgentPortalRegistered(user) {
    return user.sessionCount > 0 || Boolean(user.passwordHash);
}
function formString(formData, keys) {
    for (const key of keys) {
        const value = formData[key];
        if (typeof value === "string" && value.trim())
            return value.trim();
        if (typeof value === "number" && Number.isFinite(value))
            return String(value);
    }
    return null;
}
export function identityFromFormData(formData) {
    if (!formData || typeof formData !== "object" || Array.isArray(formData)) {
        return {};
    }
    const record = formData;
    return {
        npn: normalizeNpn(formString(record, NPN_FORM_KEYS)),
        email: normalizeEmail(formString(record, EMAIL_FORM_KEYS)),
        firstName: formString(record, FIRST_NAME_FORM_KEYS),
        lastName: formString(record, LAST_NAME_FORM_KEYS),
    };
}
export function mergeUpstreamIdentity(current, incoming) {
    return {
        npn: current.npn ?? incoming.npn ?? null,
        email: current.email ?? incoming.email ?? null,
        firstName: current.firstName ?? incoming.firstName ?? null,
        lastName: current.lastName ?? incoming.lastName ?? null,
    };
}
